import React from 'react';

class HomeSectionTwo extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let btnBgImgSection = document.querySelector('.ll__home--intro');
    let btnBgImgs = document.querySelectorAll('.btn__bgImg');
    let thisBgImg;
    Array.from(btnBgImgs).forEach(function (btnBgImg) {
      btnBgImg.addEventListener('mouseenter', function () {
        thisBgImg = this.getAttribute('data-bgImg');
        btnBgImgSection.classList.add('showing-bgimg');
        document.getElementById(thisBgImg).classList.add('is-showing');
      });
      btnBgImg.addEventListener('mouseleave', function () {
        btnBgImgSection.classList.remove('showing-bgimg');
        document.getElementById(thisBgImg).classList.remove('is-showing');
      });
    });
  }

  render() {
    let page_id = this.props.page_id;
    let handleClickTop = this.props.handleClickTop;
    let sectionData = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.section_two : [];
    let slides = sectionData.background_images && sectionData.background_images.length ? sectionData.background_images : [];
    let slideHtml = slides.map((item, key) => {
      let id = '';
      switch (key) {
        case 0:
          id = 'bg-london';
          break;
        case 1:
          id = 'bg-heritage';
          break;
        case 2:
          id = 'bg-ofc';
          break;

      }
      return (
        <img className="fullScreen" id={id} src={item.image.url} alt={item.image.alt} title={item.image.title} key={key} />
      )
    })

    return (
      <section className="section" data-hammenu="white" style={{ backgroundColor: 'rgb(222, 106, 067)' }}>
        <div className="main-container">
          <div className="ll__home--intro fullScreen">
            <h2 className="title" dangerouslySetInnerHTML={{ __html: sectionData.heading }} />
            <a href={sectionData.link} className="btn-arw right">{sectionData.link_text}</a>
            <figure>
              {slideHtml}
            </figure>
            <a href="javascript:" className="btn-arw-top w backToTop" onClick={handleClickTop}>Back to top</a>
          </div>
        </div>
      </section>
    );
  }
}

export default HomeSectionTwo;


// WEBPACK FOOTER //
// ./src/components/Home/HomeSectionTwo.js